/**
 * 业务维护接口
 **/
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessMaintainService {

  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService,
  ) {
  }

 //#region 业务维护接口
  /**
  * 新增
  * @param param
  * @returns {Observable<any>}
  */
 save(param) {
  const url = this.prefix + 'business/save';
  return this.http.Post(url, param);
}

 /**
  * 查询
  * @param param
  * @returns {Observable<any>}
  */
 queryPageList(param) {
  const url = this.prefix + 'business/queryPageList';
  return this.http.Post(url, param);
}

 /**
  * 根据ID查询
  * @param param
  * @returns {Observable<any>}
  */
 queryById(param) {
  const url = this.prefix + 'business/queryById';
  return this.http.Post(url, param);
}

/**
  * 根据ID批量删除
  * @param param
  * @returns {Observable<any>}
  */
 deleteBatch(param) {
  const url = this.prefix + 'business/deleteBatch';
  return this.http.Post(url, param);
}

/**
  * 更新
  * @param param
  * @returns {Observable<any>}
  */
 updateById(param) {
  const url = this.prefix + 'business/updateById';
  return this.http.Post(url, param);
}
 //#endregion
}
